import React from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { useMutation } from '@tanstack/react-query';
import { requestMagicLink } from '@/services/auth';
import { errorHandler } from '@/lib/utils';
import { CheckCircle, Loader2, Mail, Sparkles } from 'lucide-react';
import { Form } from '@/components/ui/form';
import { Button } from '@/components/ui/button';
import { TextField } from '@/components/text-field';
export const MagicLinkForm = () => {
    const { t } = useTranslation();
    const [magicSent, setMagicSent] = React.useState(false);
    const magicForm = useForm({
        defaultValues: {
            email: '',
        },
    });
    const magicMutation = useMutation({
        mutationFn: requestMagicLink,
        onSuccess: () => {
            setMagicSent(true);
        },
        onError: errorHandler,
    });
    return (<React.Fragment>
            {magicSent ? (<div className="text-center space-y-3 py-6">
                    <CheckCircle className="mx-auto h-10 w-10 text-primary"/>
                    <p className="text-sm">
                        {t('magic_link.sent', {
                defaultValue: 'Check your email for a secure sign-in link.',
            })}
                    </p>
                    <Button variant="ghost" onClick={() => setMagicSent(false)} className="w-full">
                        {t('back')}
                    </Button>
                </div>) : (<Form {...magicForm}>
                    <form className="space-y-4" onSubmit={magicForm.handleSubmit((data) => magicMutation.mutate(data))}>
                        <TextField control={magicForm.control} name="email" label={t('email')} placeholder="you@business.com" startIcon={<Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground"/>} required disabled={magicMutation.isPending} autoComplete="email"/>

                        <Button type="submit" className="w-full" disabled={magicMutation.isPending}>
                            {magicMutation.isPending ? (<React.Fragment>
                                    <Loader2 className="mr-2 h-4 w-4 animate-spin"/>
                                    {t('sending', { defaultValue: 'Sending…' })}
                                </React.Fragment>) : (<React.Fragment>
                                    <Sparkles className="mr-2 h-4 w-4"/>
                                    {t('send_magic_link', {
                    defaultValue: 'Send me a login link',
                })}
                                </React.Fragment>)}
                        </Button>
                    </form>
                </Form>)}
        </React.Fragment>);
};
MagicLinkForm.displayName = 'MagicLinkForm';
